import React, { useState } from "react";

export const AuthorityGate = ({
    roles = [],
    onApprove,
    onRefuse,
    busy,
    katlasStatus,
}) => {
    const [actor, setActor] = useState(
        roles[0]?.key || "cardiovascular_review_clinician"
    );

    const unconfigured = katlasStatus && katlasStatus !== "active";

    return (
        <section className="panel" data-testid="authority-gate">
            <div className="px-6 sm:px-8 py-5 border-b hairline">
                <p className="mono-label">Step 05 · Authority gate</p>
                <h2
                    className="font-serif mt-1"
                    style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                >
                    Authorised review — clinician or pharmacist decides
                </h2>
            </div>

            <div className="px-6 sm:px-8 py-6">
                <p className="mono-label mb-3">Acting as</p>
                <div className="inline-flex border border-[var(--ink)]">
                    {roles.map((r, i) => {
                        const active = actor === r.key;
                        return (
                            <button
                                key={r.key}
                                data-testid={`role-toggle-${r.key}`}
                                onClick={() => setActor(r.key)}
                                className="px-4 py-3 transition-colors"
                                style={{
                                    background: active
                                        ? "var(--ink)"
                                        : "transparent",
                                    color: active ? "#fff" : "var(--ink)",
                                    borderLeft:
                                        i === 0
                                            ? "none"
                                            : "1px solid var(--ink)",
                                    fontFamily: "IBM Plex Sans, sans-serif",
                                    fontSize: 13.5,
                                    letterSpacing: "0.01em",
                                }}
                            >
                                {r.label}
                            </button>
                        );
                    })}
                </div>

                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
                    <button
                        data-testid="authority-approve-btn"
                        className="btn-accent"
                        onClick={() => onApprove?.(actor)}
                        disabled={busy}
                    >
                        {busy
                            ? "Submitting…"
                            : "Approve cardiovascular review route"}
                    </button>
                    <button
                        data-testid="authority-refuse-btn"
                        className="btn-ghost"
                        onClick={() => onRefuse?.(actor)}
                        disabled={busy}
                    >
                        Refuse / request more information
                    </button>
                </div>

                {unconfigured && (
                    <div
                        className="mt-6 border border-[var(--rule)] bg-[var(--paper-alt)] px-4 py-3"
                        data-testid="authority-unconfigured-notice"
                    >
                        <p className="mono-label" style={{ color: "#B8860B" }}>
                            Live signing unavailable
                        </p>
                        <p
                            style={{
                                fontSize: 13.5,
                                color: "var(--ink-soft)",
                                marginTop: 4,
                            }}
                        >
                            KATLAS is currently <strong>{katlasStatus}</strong>. The
                            action will be recorded as an honest unconfigured
                            response — no simulated receipt is produced.
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default AuthorityGate;
